import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import * as Type from "./type";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import { putSaga } from "src/request/put";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { deleteSaga } from "src/request/delete";

//***CONTRACT TYPES***//
export const getContractTypes = createAction(
  "GET_CONTRACT_TYPES",
  ({ payload, params }: SagaActionParams<Type.ContractTypeDto[]>) => ({
    payload,
    url: "/api/admin/contracttype" + (params ? params : ""),
  })
);
export const getContractTypeDetails = createAction(
  "GET_CONTRACT_TYPE_DETAILS",
  ({ payload, id }: SagaActionParams<Type.ContractTypeDetailDto>) => ({
    payload,
    url: "/api/admin/contracttype/" + id,
  })
);
export const createContractType = createAction(
  "CREATE_CONTRACT_TYPE",
  ({ payload, body }: SagaActionParams<Type.ContractTypeDto>) => ({
    payload,
    url: "/api/admin/contracttype",
    body,
  })
);
export const updateContractType = createAction(
  "UPDATE_CONTRACT_TYPE",
  ({ payload, id, body }: SagaActionParams<Type.ContractTypeDto>) => ({
    payload,
    url: "/api/admin/contracttype/" + id,
    body,
  })
);
export const deleteContractType = createAction(
  "DELETE_CONTRACT_TYPE",
  ({ payload, id }: SagaActionParams<Type.ContractTypeDto>) => ({
    payload,
    url: "/api/admin/contracttype/" + id,
  })
);

const contractTypeSaga = [
  /****************CONTRACT TYPES****************/
  takeLatest<any>(
    getContractTypes.toString(),
    (payload: SagaGenericParams<Type.ContractTypeDto[]>) =>
      getSaga<Type.ContractTypeDto[]>(payload)
  ),
  takeLatest<any>(
    getContractTypeDetails.toString(),
    (payload: SagaGenericParams<Type.ContractTypeDetailDto>) =>
      getSaga<Type.ContractTypeDetailDto>(payload)
  ),
  takeLatest<any>(
    createContractType.toString(),
    (payload: SagaGenericParams<Type.ContractTypeDetailDto>) =>
      postSaga<Type.ContractTypeDetailDto>(payload)
  ),
  takeLatest<any>(
    updateContractType.toString(),
    (payload: SagaGenericParams<Type.ContractTypeDetailDto>) =>
      putSaga<Type.ContractTypeDetailDto>(payload)
  ),
  takeLatest<any>(
    deleteContractType.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.ContractTypeDetailDto>(payload)
  ),
];

export default contractTypeSaga;
